import { FC } from 'react'
import { AvatarProps } from 'antd/es/avatar'
import { useAppSelector } from '../../store/hooks'
import { FeaturedVenue as FeaturedVenueModel } from '../../models/FeaturedVenue'
import { Tag } from 'antd'
import { selectFeaturedVenuesById } from '../../store/FeaturedVenuesReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { CalendarOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'

type Props = SBModelComponent<FeaturedVenueModel> & {
  size?: AvatarProps['size']
  type?: 'full' | 'condensed'
}

const FeaturedVenuesDate: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectFeaturedVenuesById(id!))
  if (!item) {
    return <></>
  }
  return (
    <Tag icon={<CalendarOutlined />}>
      {`${dayjs(item.startDate).format('DD MMM')} - ${dayjs(item.endDate).format('DD MMM')}`}
    </Tag>
  )
}

type FeaturedVenuesDateType = { Date: typeof FeaturedVenuesDate }

export { FeaturedVenuesDate, type FeaturedVenuesDateType }
